export default __webpack_public_path__ + "static/circle-7221f94cb8f925f1fc2e3e23e83fa009.webp";